import React from "react";
import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import DataGridComponent from "@molecules/data-grid/data-grid.component";
import FeatherIcon from "feather-icons-react";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import ModalComponent from "@atoms/modal/modal.component";
import FormBuilderComponent from "@molecules/form-builder/form-builder.component";

function InventoryItemListTemplateComponent({
  templateModal: { tableTitle, keyColumn, breadCrumbs, tableColumn, tableData, totalCount, filters, tableParams, openUploadModal,openUploadModalWithoutSpecs,formInputs,formTriggers,categories,uploadFormData,hideFooter },
  templateEvents: { getInventoryItemsData, handleCreateClick, deleteRecords, submitFilter ,handleUploadClick,handleFieldChange,handleUploadSubmit,handleUploadCancel,handleDownloadSample,handleDownloadSampleWithoutSpecs,handleUploadClickwithoutspecs},
}) {
  const settingFormEdit = `${breadCrumbs[0].menu_url}/edit`;

  const ActionContent = () => (
    <>
      <button type="button" className="btn btn-primary btn-sm" onClick={handleUploadClick} style={{ marginRight: 10 }}>
        <FeatherIcon icon="upload" size={17} />
      </button>
      <button type="button" className="btn btn-outline-primary btn-sm" onClick={handleUploadClickwithoutspecs} style={{ marginRight: 10 }}>
        <FeatherIcon icon="upload" size={17} />
      </button>
      <button type="button" className="btn btn-outline-primary btn-sm" onClick={handleCreateClick}>
        <FeatherIcon icon="plus" size={17} />
      </button>
    </>
  );
  const DynamicFormFields = ({ fields, onChange }) => {
    const categoryField = fields?.find(f => f.name === "category_id");
    const fileField = fields?.find(f => f.name === "file");
  
    
  
    return (
      <div className="d-flex flex-column gap-2">
        <select
          value={categoryField?.value || ""}
          onChange={(e) => onChange("category_id", e.target.value)}
          className="form-select"
        >
          <option value="">Select the Category</option>
          {categories?.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.name}
            </option>
          ))}
        </select>
  
        <div>
          <input
            type="file"
            onChange={(e) => onChange("file", e.target.files[0])}
            className="form-control"
          />
          {fileField?.value && (
            <p className="mt-1 d-block">
              Selected file: {fileField.value.name}
            </p>
          )}
        </div>
        <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary" style={{width:"40%"}} onClick={handleDownloadSample}>
          Download Sample
        </button>
        </div>
      </div>
    );
  };
   const DynamicFormFieldsWithoutSpecs = ({ fields, onChange }) => {
    const categoryField = fields?.find(f => f.name === "category_id");
    const fileField = fields?.find(f => f.name === "file");
  
    
  
    return (
      <div className="d-flex flex-column gap-2">
        <select
          value={categoryField?.value || ""}
          onChange={(e) => onChange("category_id", e.target.value)}
          className="form-select"
        >
          <option value="">Select the Category</option>
          {categories?.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.name}
            </option>
          ))}
        </select>
  
        <div>
          <input
            type="file"
            onChange={(e) => onChange("file", e.target.files[0])}
            className="form-control"
          />
          {fileField?.value && (
            <p className="mt-1 d-block">
              Selected file: {fileField.value.name}
            </p>
          )}
        </div>
        <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary" style={{width:"40%"}} onClick={handleDownloadSampleWithoutSpecs}>
          Download Sample
        </button>
        </div>
      </div>
    );
  };
  
  
  return (
    <>
      <PageWrapperComponent>
        <PageHeadComponent title="Inventory Items" breadCrumbs={breadCrumbs} actionContent={<ActionContent />} />
        <DataGridComponent
          title={tableTitle}
          keyColumn={keyColumn}
          tableData={tableData}
          tableColumn={tableColumn}
          totalCount={totalCount}
          dataRefresh={getInventoryItemsData}
          editLink={settingFormEdit}
          deleteRecords={deleteRecords}
          breadCrumbs={breadCrumbs}
          filters={filters}
          submitFilter={submitFilter}
          tableParams={tableParams}
          disableDelete
        />
      </PageWrapperComponent>

      <ModalComponent
        open={openUploadModal}
        secondaryAction={handleUploadCancel}
        title="Upload Inventory File !"
        primaryText="Submit"
        primaryAction={handleUploadSubmit}
        secondaryText="Cancel"
        hideFooter={hideFooter}
      >
        <DynamicFormFields fields={uploadFormData} onChange={handleFieldChange} />
      </ModalComponent>

      <ModalComponent
        open={openUploadModalWithoutSpecs}
        secondaryAction={handleUploadCancel}
        title="Upload Inventory File (Without Specs) !"
        primaryText="Submit"
        primaryAction={handleUploadSubmit}
        secondaryText="Cancel"
        hideFooter={hideFooter}
      >
        <DynamicFormFieldsWithoutSpecs fields={uploadFormData} onChange={handleFieldChange} />
      </ModalComponent>

    </>
  );
}

export default InventoryItemListTemplateComponent;
